var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full"},[_c('ProgressBar',{ref:"progressBar"}),_c('router-view',{key:_vm.$route.path}),_c('portal-target',{attrs:{"name":"modals","multiple":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }